import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  Stack,
  Typography,
} from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { formatCurrency, formatNumber } from "../../../../../infrastructure/utils/formatters";
import { CONTRACTOR_PORTAL_BASE } from "../contractorPortalNav";
import ContractorStatusBadge from "./ContractorStatusBadge";

const ContractorProjectCard = ({ project }) => {
  if (!project) return null;

  const progress =
    project.progressPercent == null
      ? "—"
      : `${formatNumber(project.progressPercent)}٪`;

  return (
    <Card
      variant="outlined"
      data-testid={`contractor-project-card-${project.id}`}
      sx={{ height: "100%" }}
    >
      <CardContent>
        <Stack spacing={1}>
          <Typography variant="subtitle1" fontWeight={700}>
            {project.projectCode || `پروژه #${project.id}`}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            ظرفیت: {project.capacity || "—"}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            شهر: {project.city || "—"}
          </Typography>
          <Stack direction="row" spacing={1} alignItems="center">
            <Typography variant="body2" color="text.secondary">
              وضعیت اجرا:
            </Typography>
            <ContractorStatusBadge
              status={project.executionStatus}
              statusTitle={project.executionStatusTitle}
            />
          </Stack>
          <Typography variant="body2">پیشرفت: {progress}</Typography>
          <Typography variant="body2" fontWeight={600}>
            مبلغ قرارداد:{" "}
            {project.contractAmount != null
              ? formatCurrency(project.contractAmount, "rial")
              : "—"}
          </Typography>
        </Stack>
      </CardContent>
      <CardActions sx={{ px: 2, pb: 2 }}>
        <Button
          component={RouterLink}
          to={`${CONTRACTOR_PORTAL_BASE}/projects/${project.id}`}
          size="small"
          variant="contained"
          data-testid={`contractor-project-view-${project.id}`}
        >
          مشاهده پروژه
        </Button>
        <Box
          component="span"
          data-testid="contractor-project-privacy-guard"
          sx={{ display: "none" }}
          aria-hidden
        >
          {/* Privacy: never expose customer selling price, margin, or lending here. */}
        </Box>
      </CardActions>
    </Card>
  );
};

export default ContractorProjectCard;
